import Main_Router from "./Routes/Route";
import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import DeltaSocketClient from "./Utils/main/DeltaSocket";
import Notfound from "./404";
import axios from "axios";
import * as Config from "./Utils/Config";
import { useDispatch } from "react-redux";

import { Get_Company_Logo } from "./ReduxStore/Slice/Admin/AdminSlice";

const App = () => {
  const dispatch = useDispatch();

  const pageRef = useRef(null);

  const [panelstatus, setPanelStatus] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loaderImage, setLoaderImage] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");

  const GetCompanyStatus = async () => {
    try {
      const response = await axios.get(`${Config.base_url}get/panelstatus`);

      if (response.data?.status) {
        localStorage.setItem(
          "company_status",
          response.data?.data[0]?.isActive || 1
        );
        setPanelStatus(response.data?.data[0]?.isActive == 0 ? false : true);
      }
    } catch (error) {
      console.error("Error fetching company status:", error);
    }
  };

  const CompanyName = async () => {
    try {
      const response = await dispatch(Get_Company_Logo()).unwrap();
      if (response.status && response.data && response.data.length > 0) {
        const companyData = response.data[0];
        // Set the permission flag (1 for Home, 0 for Login)
        setCompanyLogo(companyData.landing_page_permission || 0);
        
        const currentLoader = companyData.loader_image || "https://cdn3d.iconscout.com/3d/premium/thumb/bitcoin-3d-icon-png-download-12385354.png";
        setLoaderImage(currentLoader);

        // Update the DOM loader image immediately
        const domLoaderImg = document.getElementById("dynamic-loader-img");
        if (domLoaderImg) {
          domLoaderImg.src = currentLoader;
        }

        // Save for next time
        localStorage.setItem("loader_image", currentLoader);
      } else {
        // Handle case where API succeeds but no data is found
        const defaultLoader = "https://cdn3d.iconscout.com/3d/premium/thumb/bitcoin-3d-icon-png-download-12385354.png";
        const domLoaderImg = document.getElementById("dynamic-loader-img");
        if (domLoaderImg) {
          domLoaderImg.src = defaultLoader;
        }
        localStorage.setItem("loader_image", defaultLoader);
      }
    } catch (error) {
      console.error("CompanyName error:", error);
      const defaultLoader = "https://cdn3d.iconscout.com/3d/premium/thumb/bitcoin-3d-icon-png-download-12385354.png";
      const domLoaderImg = document.getElementById("dynamic-loader-img");
      if (domLoaderImg) {
        domLoaderImg.src = defaultLoader;
      }
      localStorage.setItem("loader_image", defaultLoader);
    }
  };

  useEffect(() => {
    CompanyName();
    GetCompanyStatus();
    const timer = setTimeout(() => {
      setLoading(false);
      // Hide the loader from index.html
      const loader = document.getElementById("startup-loader");
      if (loader) {
        loader.style.display = "none";
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="App">
      <div className="" ref={pageRef}>
        {/* actual page content */}
        {!panelstatus ? (
          <Notfound />
        ) : (
          <Main_Router companyLogo={companyLogo} />
        )}
      </div>
    </div>
  );
};

export default App;
